<!--  -->
<template>
  <div class="enterprise-main">
    <div id="enterprise" class="enterprise"></div>
  </div>
</template>

<script>
export default {
  name: "agemain2",
  data() {
    return {};
  },
  mounted() {
    this.drawLine();
  },
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let enterprise = this.$echarts.init(
        document.getElementById("enterprise")
      );

      var weatherIcons = {
        Sunny: 6 + "data/asset/img/weather/sunny_128.png",
        Cloudy: 7 + "data/asset/img/weather/cloudy_128.png",
        Showers: 8 + "data/asset/img/weather/showers_128.png"
      };

      // 绘制图表
      enterprise.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          //   top: 'middle',
          bottom: 80,
          right: 10,
          textStyle: { color: "#ffffff", fontSize: 16 },
          data: ["勘察", "设计", "施工", "运维"]
        },
        series: [
          {
            label: {
              normal: {
                position: "inner",
                show: false
              }
            },
            label: {
              //饼图图形上的文本标签
              normal: {
                show: true,
                position: "inner", //标签的位置
                textStyle: {
                  fontWeight: 500,
                  fontSize: 18 //文字的字体大小,
                  //   color:'red'
                },
                formatter: "{d}"
              }
            },
            color: ["#0083D0", "#67EEFF", "#7E9E86", "#E98F6F"],
            type: "pie",
            radius: "80%",
            center: ["35%", "50%"],
            selectedMode: "single",
            labelLine: {
              normal: {
                // show: true
              }
            },
            data: [
              { value: 510, name: "勘察" },
              { value: 510, name: "设计" },
              { value: 510, name: "施工" },
              { value: 510, name: "运维" }
            ]
          }
        ]
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.enterprise {
  width: 100%;
  height: 100%;
}
</style>
